<template>
    <div class="row justify-content-center">
        <div class="container-fluid col-md-10" style="background:rgb(248,249,250); border-radius: 10px; box-shadow: 5px 5px 5px 5px #999999;" id="contenedor">
            <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
            <h3 class="text-center"><b>Editar Cheque</b></h3><br>
            
            <form enctype="multipart/form-data" @submit.prevent="onFormSubmit">
            
                <div class="row">
                     <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT facturación</label>
                       
                        </div>
                        <div class="input-group mb-3">
                         <input type="text" id="rutF" class="form-control" placeholder="Ingrese RUT facturación" style="border-color:rgb(237,126,37)"  required>
                        <div class="input-group-append">
                           <button  id="btnBuscar" class="btn btn-primary" @click="buscarUltimoRegistro()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search "></i></button>
                        </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>N° documento</label>
                        <input type="text" id="nDoc" class="form-control" placeholder="Ingrese n° documento" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT titular</label>
                        <input type="text" id="rutT" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre titular</label>
                        <input type="text" id="nombreT" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón social</label>
                        <input type="text" id="razonS" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label>Monto del cheque</label>
                            <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border-color:rgb(237,126,37)">$</span>
                            </div>
                           <input type="text" id="monto" class="form-control" placeholder="Ingrese monto" style="border-color:rgb(237,126,37)"  required>
                        
                            </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" rows="3" v-model="cheque.observacion" style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import { db } from '../firebaseDb';
    export default {
        data() {
            return {
                cheque: {
                },
                
            }
        },
        created() {
            let dbRef = db.collection('cheques').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                
                //this.cheque = doc.data();
                document.getElementById("rutF").value=doc.data().rutFacturacion
                document.getElementById("nDoc").value=doc.data().documento
                document.getElementById("rutT").value=doc.data().rut
                document.getElementById("nombreT").value=doc.data().nombreTitular
                document.getElementById("razonS").value=doc.data().razonSocial
                document.getElementById("monto").value=doc.data().monto
                document.getElementById("observacion").value=doc.data().observacion
            }).catch((error) => {
                console.log(error)
            })
            this.cargarCampos();
        },
        methods: {
            onUpdateForm(event) {
                event.preventDefault()
                db.collection('cheques').doc(this.$route.params.id)
                .update(this.cheque).then(() => {
                    console.log("Cheque actualizado");
                    this.$router.push('/list')
                }).catch((error) => {
                    console.log(error);
                });
                this.subirImagen();
            },
            
           
        }
    }
</script>